import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../src/pages/sidebar";
import Login from '../src/pages/login';
import ProtectedRoute from '../src/protected'
import ForgotPassword from "./pages/forgot";
import Errorpage from "./pages/Errorpage.js";
import ResetPassword from "./pages/reset";
import { useEffect } from "react";
import { makeApiRequest } from "./axiosService/apiCall";
import Viewhistory from "./pages/Viewhistory.js";


function App() {
  // useEffect(() => {
  //   let adminAuth = async () => {
  //     let adminToken = localStorage.getItem('token');
  //     // console.log("adminToken",adminToken);
  //     let params = {
  //       url: "admin-auth",
  //       method: "POST",
  //     }
  //     let response = await makeApiRequest(params);
  //     if (response.status) {
  //       // console.log("response API",response);
  //     } else {
  //       // localStorage.clear()  
  //     }
  //   }
  //   adminAuth();
  // }, [])

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path="/logout" element={<Sidebar />} />

          <Route path="/user-Details" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />
              {" "}
            </ProtectedRoute>
          }
          />

          <Route path="/Transaction-history" element={
            <ProtectedRoute>
             {" "}
            <Sidebar />
             {" "}
             </ProtectedRoute>
          }
          />

          <Route path="/kyc-status" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />
              {" "}
            </ProtectedRoute>
          }
          />

          <Route path="/admin-transfer-history" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />
              {" "}
            </ProtectedRoute>
          }
          />
          <Route path="/admin-manualtransfer-history" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />
              {" "}
            </ProtectedRoute>
          }
          />

          <Route path="/admin-settings" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />
              {" "}
            </ProtectedRoute>
          }
          />

          <Route path="/userWallet-details" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />
              {" "}
            </ProtectedRoute>
          }
          />

          <Route path="/referral-status" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />
              {" "}
            </ProtectedRoute>
          }
          />

          <Route path="/error" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route exact path="/forgotPassword/:token" element={<ResetPassword />} />
          <Route exact path="/" element={<Login />} />
          <Route exact path="*" element={<Errorpage />} />
          {/* <Route path="/dashboard" element={<ProtectedRoute><Sidebar /></ProtectedRoute>} /> */}
          {/* <Route path="/dashboard" element={<Sidebar />} /> */}
          <Route path="/Transaction-Admin-manual-coin" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route path="/Kyc-details" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route path="/Withdraw-request" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route path="/Rewardranking" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route path="/Plane-reward" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route path="/admin-wallet" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          {/* <Route path="/Kyc-details" element={<Sidebar />} /> */}
          {/* <Route path="/Withdraw-request" element={<Sidebar />} /> */}
          {/* <Route path="/Rewardranking" element={<Sidebar />} /> */}
          {/* <Route path="/Plane-reward" element={<Sidebar />} /> */}
          {/* <Route path="/admin-wallet" element={<Sidebar />} /> */}
          <Route path="/Claim-History" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route path="/user-stake-details" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route path="/texa-wallet-transfer" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route path="/user-level-income-history" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route path="/view-history" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route path="/restake-request" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route path="/transfer-wallet-request" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route path="/admin-claim-history" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />
          <Route path="/view-history" element={
            <ProtectedRoute>
              {" "}
            </ProtectedRoute>
          }
          />
          {/* <Route path="/user-stake-details" element={<Sidebar />} /> */}
          {/* <Route path="/texa-wallet-transfer" element={<Sidebar />} /> */}
          {/* <Route path="/user-level-income-history" element={<Sidebar />} /> */}
          {/* <Route path="/view-history" element={<Sidebar />} /> */}
          {/* <Route path="/restake-request" element={<Sidebar />} /> */}
          {/* <Route path="/transfer-wallet-request" element={<Sidebar />} /> */}
          {/* <Route path="/admin-claim-history" element={<Sidebar />} /> */}
          {/* <Route exact path="/view-history" element={<Viewhistory />} /> */}
          <Route path="/Restake-plan" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />{" "}
            </ProtectedRoute>
          }
          />

          <Route path="/admin-referral" element={
            <ProtectedRoute>
              {" "}
              <Sidebar />
              {" "}
            </ProtectedRoute>
          }
          />

        </Routes>

      </BrowserRouter>
    </div>
  );
}

export default App;